import MetaBox from './MetaBox';
import type {PluginSettings} from '@wordpress/plugins';
import {__} from '@wordpress/i18n';
import type {PluginModule} from '@lipemat/js-boilerplate-gutenberg';
import Allowed from './Allowed';

// Backward compatibility for WordPress < 6.6.
// @ts-ignore
const PluginDocumentSettingPanel = window.wp?.editor?.PluginDocumentSettingPanel ?? ( window.wp?.editPost?.PluginDocumentSettingPanel ?? window.wp?.editSite?.PluginDocumentSettingPanel ) ?? ( ( {children} ) => children );


type Module = PluginModule<PluginSettings>;

export const name: Module['name'] = 'advanced-sidebar-menu-pro-title-meta-box';

export const settings: Module['settings'] = {
	icon: 'welcome-widgets-menus',
	render: () => {
		return (
			<Allowed>
				{() => (
					<PluginDocumentSettingPanel
						name={name}
						title={__( 'Advanced Sidebar', 'advanced-sidebar-menu' )}
						icon={'welcome-widgets-menus'}
					>
						<MetaBox />
					</PluginDocumentSettingPanel>
				)}
			</Allowed>
		);
	},
};
